import React, { createContext, useState } from "react";

export const SettingContext = createContext();

export const SettingProvider = (props) => {
  const [companyInfo, setCompanyInfo] = useState([]);
  const [companyServiceArea, setCompanyServiceArea] = useState([]);
  const [generalSettings, setGeneralSettings] = useState([]);
  const [paymenetmethod, setPaymenetmethod] = useState([]);
  const [emailData, setEmailData] = useState([]);
  const [emailTemplate, setEmailTemplate] = useState([]);
  const [promocodeData, setPromocodeData] = useState([]);
  const [zonesdata, setZonesData] = useState([]);
  const [smsstatus, setSmsstatus] = useState([]);
  const [masterpassword, setMasterpassword] = useState("");
  const [searcpricestatus, setSearcpricestatus] = useState(false);
  const [Tagsdata, setTagData] = useState([]);




  return (
    <SettingContext.Provider value={[companyInfo, setCompanyInfo, companyServiceArea, setCompanyServiceArea, generalSettings, setGeneralSettings, paymenetmethod, setPaymenetmethod, emailData, setEmailData, emailTemplate, setEmailTemplate, promocodeData, setPromocodeData, zonesdata, setZonesData, smsstatus, setSmsstatus, masterpassword, setMasterpassword, searcpricestatus, setSearcpricestatus, Tagsdata, setTagData]}>
      {props.children}
    </SettingContext.Provider>
  );
};



